import LayoutComp from "./Components/LayoutComp";
import Login from "./Pages/Auth/Login";
import "./App.css";
import { useState, useEffect } from "react";
import LoadingPage from "./Pages/LoadingPage";
//import "antd/dist/reset.css";
import "./../node_modules/antd/dist/antd";
import "./../node_modules/antd/dist/antd.min.js"; 
import "./../node_modules/antd/dist/reset.css";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const auth = localStorage.getItem("auth");
    setIsLoggedIn(auth === "true");
    setLoading(false);
  }, []);

  if (loading) {
    return <LoadingPage />; 
  }

  return <>{isLoggedIn ? <LayoutComp /> : <Login />}</>;
}

export default App;
